const KEY = 'relay.returnTo';

/**
 * Remember the page the driver was on before they were sent to Auth0.
 *
 * Auth0's redirect_uri is the origin, so a driver who opens a link to a
 * checklist while signed out comes back to the home screen and the link is
 * gone. Saved here on the way out, read once on the way back.
 *
 * '/' is not worth saving, and '/invitation' carries its own token in the
 * query and runs before sign in, so sending a driver back to it would replay
 * an invitation they have already accepted.
 */
export function rememberReturnTo(): void {
  try {
    const path = window.location.pathname + window.location.search;
    if (
      window.location.pathname === '/' ||
      window.location.pathname === '/invitation'
    ) {
      return;
    }
    sessionStorage.setItem(KEY, path);
  } catch {
    // Private mode and locked-down webviews throw on sessionStorage. Losing
    // the link is worse than nothing, not worth breaking sign in over.
  }
}

/** Read the remembered page and forget it, so it is used exactly once. */
export function takeReturnTo(): string | null {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return path;
  } catch {
    return null;
  }
}
